<template>
	<div class="app-container">
	</div>
</template>

<script>
	import { getMpOpenId  } from '@/api/jcc'
	export default {
		name: "business-push-message",
		data() {
			return {
			};
		},
        create(){
            let script = document.createElement('script');
            script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
        },
		mounted() {
            console.log('12222---')
			let option = this.searchObj(location.search)
            console.log('option---',option)
			if (option.bindYhbAppId && option.timestamp) {
				if (option.code) {
                    console.log('传参---',{
						mpCode: option.code,
                        clientType: option.clientType,
                        id: option.id,
                        type: 2
					})
					getMpOpenId({
						mpCode: option.code,
                        clientType: option.clientType,
                        id: option.id,
                        type: 2
					}).then((res) => {
                        console.log('111---',res)
					}).finally((err) => {
                        console.log('222---',err)
					});
				} else {
	
					let loc_href = `https://h5-dl.yhbtest.com/business-push-message?bindYhbAppId=${option.bindYhbAppId}&clientType=${option.clientType}&id=${option.id}&timestamp=${option.timestamp}`
					loc_href = encodeURIComponent(loc_href);
					var url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxb61c18690a32470d&redirect_uri=${loc_href}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
					location.href = url;
				}
				return
			}
		},
		methods: {
			// 处理重定向链接有相同code处理
			searchObj(str) {
				//去掉？
				var str = str.slice(1);
				//根据“&”分割字符串
				var arr = str.split("&");
				//定义空的obj，保存对象
				var obj = {};
				//循环遍历分割后的数组
				for (var p of arr) {
					//根据“=”分割
					var arr2 = p.split("=");
					//解构
					var [name, value] = arr2;
					//如果obj中的name为undefined就把值填进去，否则就连接
					if (obj[name] == undefined) {
						obj[name] = value;
					} else {
						obj[name] = [].concat(value, obj[name]);
					}
				}
				return obj;
			},
		},
	};
</script>

<style scoped>
</style>
